<template>
    <div class="page">
        <div class="page-title">
            <img src="@/modules/sn//assets/images/icon-barcode.png" />
            <span> 条码字符串：{{ barcodeNo }} </span>
        </div>
        <div class="page-container">
            <div class="page-left">
                <baseInfo :barcodeNo="barcodeNo" />
            </div>
            <div class="page-right">
                <div class="radio-box">
                    <div class="radio-groub">
                        <div
                            v-for="(item, index) in tabs"
                            :class="[
                                'tab',
                                { active: tabActiveIndex === index }
                            ]"
                            :key="index"
                            @click="tabClick(index)"
                        >
                            <span>{{ item.label }}</span>
                        </div>
                    </div>
                </div>
                <keep-alive>
                    <component
                        :is="activeComponment"
                        :barcodeNo="barcodeNo"
                    ></component>
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import baseInfo from './baseInfo.vue';
import procress from './process.vue';
import barcodeProduce from './barcodeProduce';
export default {
    components: {
        barcodeProduce,
        baseInfo,
        procress
    },
    props: {
        barcodeNo: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            tabs: [
                {
                    label: '条码全流程',
                    component: 'procress'
                },
                {
                    label: '工厂制造',
                    component: 'barcodeProduce'
                }
            ],
            tabActiveIndex: 0,
            activeComponment: 'procress'
        };
    },
    methods: {
        tabClick(i) {
            this.tabActiveIndex = i;
            this.activeComponment = this.tabs[i].component;
        }
    }
};
</script>

<style lang="less" scoped>
.page-container {
    display: flex;
}
.page-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    img {
        width: 20px;
        margin-right: 5px;
    }
}
.page-left {
    margin-top: 15px;
    width: 320px;
    flex-shrink: 0;
    border-right: 1px solid #e5e5e5;
}
.page-right {
    flex-shrink: 0;
}
.radio-box {
    display: inline-block;
    // margin-top: 45px;
    margin-left: 20px;
}
.radio-groub {
    display: flex;
    padding: 4px;
    border-radius: 20px;
    background: #f5f5f5;
    .tab {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 106px;
        height: 28px;
        font-size: 14px;
        color: #333333;
        text-align: center;
        font-weight: 600;
    }
    .active {
        border-radius: 16px;
        color: #4285f5;
        background: #ffffff;
    }
}
</style>
